import { Indicator, IndicatorGroup } from '@/components/survey/common/ui';
import common from '@/components/survey/common/ui/styles/common.module.scss';

interface Props {
  isCompletedEvery: boolean;
}

export const HomeIndicator = ({ isCompletedEvery }: Props) => {
  return (
    <header className={common.flow_header}>
      <h1 className={common.flow_title}>사업장별 질문</h1>
      {!isCompletedEvery && (
        <IndicatorGroup>
          <Indicator active={false}>1</Indicator>
          <Indicator active={false}>2</Indicator>
          <Indicator active>3</Indicator>
        </IndicatorGroup>
      )}
    </header>
  );
};
